export * from './infictious-info.component';